import shop from "@/api/productCategories";
// initial state
const state = {
  all: [],
  ProductCategory: {},
  selectedProductCategories: []
};
// getters
const getters = {
  ProductCategory: state => {
    return state.ProductCategory;
  }
};

// actions
const actions = {
  async getAllProductCategories({ commit }) {
    let d = (await shop.getProductCategories()).data;
    commit("getProductCategories", d);
    return d;
  },

  getProductCategory: async (context, id) => {
    let d = (await shop.getProductCategory(id)).data;
    context.commit("getProductCategory", d);
    return d;
  }
};

// mutations
const mutations = {
  getProductCategories(state, ProductCategories) {
    state.all = ProductCategories;
  },
  setSelectedProductCategories(state, ProductCategories) {
    state.selectedProductCategories = ProductCategories;
  },
  getProductCategory(state, ProductCategory) {
    //state.ProductCategory = ProductCategory
    state.ProductCategory = null;
    state.ProductCategory = Object.assign(
      {},
      state.ProductCategory,
      ProductCategory
    );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
